export default {
    // 资源查询接口
    queryResourceInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listResourceInfo', params, response);
    },
    // 删除资源接口
    deleteResource(params, response) {
        window.vue.$apiAxios.get('/databusserver/interfaceManager/deleteResource', params, response);
    },
    // 添加资源接口
    addResource(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/insertResource', params, response);
    },
    // 更新资源信息
    updateResource(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/updateResource', params, response);
    },
    // 获取mq和通道关联信息列表
    getMqChannerList(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/listMqChanners', params, response);
    },
    // 修改资源状态
    updateResourceStatu(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/updateResourceStatu', params, response);
    },
    // 检测资源名称是否重复
    checkResNameRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/checkResNameRepeat', params, response);
    },
    // 检测资源ID是否重复
    checkResIdRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/checkResIdRepeat', params, response);
    }
};
